// extracted by mini-css-extract-plugin
export default {"wrapper":"crud_wrapper__S8uYq","tabsWrapper":"crud_tabsWrapper__OOMgx","tabWrapper":"crud_tabWrapper__PVKwa","statusCode":"crud_statusCode__BLXzM","JSONdata":"crud_JSONdata__DxV2a"};